import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { PAGES } from 'utils/pages';
import { selectProductItems } from 'Product/store/selectors';


const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const products = useSelector(selectProductItems);

  useEffect(() => {
    const detectLanguageFromQuery = (): 'de' | 'en' | null => {
      try {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get('lang');
        if (lang === 'de' || lang === 'en') {
          return lang;
        }
      } catch {
      }
      return null;
    };

    const detectLanguageFromPath = (pathname: string): 'de' | 'en' | null => {
      const trimmedPath = pathname.replace(/\/+$/, '') || '/';

      if (trimmedPath === '/') {
        return null;
      }

      const path = trimmedPath.toLowerCase();
      const segments = path.split('/').filter(Boolean);
      const firstSegment = segments[0];

      if (firstSegment === 'product' && segments.length >= 3 && Array.isArray(products) && products.length) {
        const categorySlug = segments[1] || '';
        const typeSlug = segments[2] || '';
        const repairSlug = segments[3] || '';

        let categoryEn = false;
        let categoryDe = false;
        let typeEn = false;
        let typeDe = false;
        let repairEn = false;
        let repairDe = false;

        products.forEach((product) => {
          if (!product) return;

          const catSeoEn = product.productCategory?.seo?.en;
          const catSeoDe = product.productCategory?.seo?.de;
          const typeSeoEn = product.productType?.seo?.en;
          const typeSeoDe = product.productType?.seo?.de;
          const repairSeoEn = product.seo?.en;
          const repairSeoDe = product.seo?.de;

          if (categorySlug) {
            if (catSeoEn === categorySlug) categoryEn = true;
            if (catSeoDe === categorySlug) categoryDe = true;
          }

          if (typeSlug) {
            if (typeSeoEn === typeSlug) typeEn = true;
            if (typeSeoDe === typeSlug) typeDe = true;
          }

          if (repairSlug) {
            if (repairSeoEn === repairSlug) repairEn = true;
            if (repairSeoDe === repairSlug) repairDe = true;
          }
        });

        if (repairSlug) {
          if (repairEn && !repairDe) return 'en';
          if (repairDe && !repairEn) return 'de';
        }

        if (typeSlug) {
          if (typeEn && !typeDe) return 'en';
          if (typeDe && !typeEn) return 'de';
        }

        if (categorySlug) {
          if (categoryEn && !categoryDe) return 'en';
          if (categoryDe && !categoryEn) return 'de';
        }
      }

      const matchesLanguage = (language: 'de' | 'en'): boolean => {
        const routes = PAGES[language];

        return Object.values(routes).some((value) => {
          const baseSegment = value.split('/:')[0].toLowerCase();

          if (!baseSegment) {
            return false;
          }

          return firstSegment === baseSegment || path.startsWith(`/${baseSegment}/`);
        });
      };

      const isGerman = matchesLanguage('de');
      const isEnglish = matchesLanguage('en');

      if (isGerman && !isEnglish) {
        return 'de';
      }

      if (isEnglish && !isGerman) {
        return 'en';
      }

      return null;
    };

    const { pathname } = window.location;

    const languageFromQuery = detectLanguageFromQuery();
    if (languageFromQuery && languageFromQuery !== i18n.language) {
      i18n.changeLanguage(languageFromQuery);
      Cookies.set('language', languageFromQuery, { expires: 30 });
      return;
    }

    const languageFromPath = detectLanguageFromPath(pathname);

    if (languageFromPath && languageFromPath !== i18n.language) {
      i18n.changeLanguage(languageFromPath);
      Cookies.set('language', languageFromPath, { expires: 30 });
    }
  }, [i18n.language, products]);

  return (
    <div />
  );
};

export default LanguageToggle;
